import script from "./WizardConnectStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardConnectStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardConnectStep.vue?vue&type=style&index=0&id=2f06878e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f06878e"]])

export default __exports__